import type { BrowseCategorySlug } from '@engage/browse-categories/models';

export const LIBRARY_CATEGORY_SELECTION_ROUTE = '/classes';
export const LIBRARY_CATEGORY_ROUTE = '/classes/:categorySlug';

export const toLibraryCategoryRoute = (categorySlug: BrowseCategorySlug) =>
  `/classes/${categorySlug}`;
